<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="7" width="9.5" height="9.5" rx="2"/><path d="M13 4.6a2 2 0 0 0-2-1.1H5.5a2 2 0 0 0-2 2V11c0 .9.6 1.7 1.4 1.9"/></svg>
</template>
